"use strict"; // tslint:disable:max-classes-per-file

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var moment = require("moment");

var AdtFlag_1 = require("../../core/model/AdtFlag");
/** Warning flags for entity {@link Window} */


var WindowWarningFlag =
/*#__PURE__*/
function (_AdtFlag_1$AdtFlag) {
  _inherits(WindowWarningFlag, _AdtFlag_1$AdtFlag);

  function WindowWarningFlag(messageKey, messageVars) {
    var _this;

    _classCallCheck(this, WindowWarningFlag);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowWarningFlag).call(this));
    _this.messageKey = messageKey;
    _this.messageVars = messageVars;
    return _this;
  }

  _createClass(WindowWarningFlag, [{
    key: "validate",

    /**
     * @inheritDoc
     */
    value: function validate() {
      return true;
    }
  }], [{
    key: "register",
    value: function register(ctor, tag) {
      return AdtFlag_1.AdtFlag.registerBase(WindowWarningFlag, ctor, tag);
    }
  }, {
    key: "deserialize",
    value: function deserialize(data) {
      return AdtFlag_1.AdtFlag.deserializeBase(WindowWarningFlag, data);
    }
  }]);

  return WindowWarningFlag;
}(AdtFlag_1.AdtFlag);

exports.WindowWarningFlag = WindowWarningFlag;
WindowWarningFlag.TAG = '__WindowItemFlag__';
/** Leaflet text is required but not present */

var ValueMissingLeafletText =
/*#__PURE__*/
function (_WindowWarningFlag) {
  _inherits(ValueMissingLeafletText, _WindowWarningFlag);

  function ValueMissingLeafletText() {
    _classCallCheck(this, ValueMissingLeafletText);

    return _possibleConstructorReturn(this, _getPrototypeOf(ValueMissingLeafletText).apply(this, arguments));
  }

  return ValueMissingLeafletText;
}(WindowWarningFlag);

exports.ValueMissingLeafletText = ValueMissingLeafletText;
ValueMissingLeafletText.TAG = WindowWarningFlag.register(ValueMissingLeafletText);
/** Page number is required but not present */

var ValueMissingPageNumber =
/*#__PURE__*/
function (_WindowWarningFlag2) {
  _inherits(ValueMissingPageNumber, _WindowWarningFlag2);

  function ValueMissingPageNumber() {
    _classCallCheck(this, ValueMissingPageNumber);

    return _possibleConstructorReturn(this, _getPrototypeOf(ValueMissingPageNumber).apply(this, arguments));
  }

  return ValueMissingPageNumber;
}(WindowWarningFlag);

exports.ValueMissingPageNumber = ValueMissingPageNumber;
ValueMissingPageNumber.TAG = WindowWarningFlag.register(ValueMissingPageNumber);

var PromoPriceValidityStartInvalid =
/*#__PURE__*/
function (_WindowWarningFlag3) {
  _inherits(PromoPriceValidityStartInvalid, _WindowWarningFlag3);

  function PromoPriceValidityStartInvalid() {
    _classCallCheck(this, PromoPriceValidityStartInvalid);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromoPriceValidityStartInvalid).apply(this, arguments));
  }

  return PromoPriceValidityStartInvalid;
}(WindowWarningFlag);

exports.PromoPriceValidityStartInvalid = PromoPriceValidityStartInvalid;
PromoPriceValidityStartInvalid.TAG = WindowWarningFlag.register(PromoPriceValidityStartInvalid);
/** Window was affected by change of product category structure. */

var WindowAffectedByCategoryChange =
/*#__PURE__*/
function (_WindowWarningFlag4) {
  _inherits(WindowAffectedByCategoryChange, _WindowWarningFlag4);

  /**
   * Creates new instance of warning flag with default message and current date and time.
   */
  function WindowAffectedByCategoryChange() {
    _classCallCheck(this, WindowAffectedByCategoryChange);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowAffectedByCategoryChange).call(this, WindowAffectedByCategoryChange.name, [moment().toISOString()]));
  }

  return WindowAffectedByCategoryChange;
}(WindowWarningFlag);

exports.WindowAffectedByCategoryChange = WindowAffectedByCategoryChange;
WindowAffectedByCategoryChange.TAG = WindowWarningFlag.register(WindowAffectedByCategoryChange);